import React, { FC, useCallback } from 'react'

import { useMutation } from '@apollo/client'
import clsx from 'clsx'

import { UPDATE_CART } from 'Const'
import useToggle from 'Hooks/useToggle'

interface Props {
  utensils: boolean
}

const Utensils: FC<Props> = ({ utensils }) => {
  const [isShowControls, , showControls] = useToggle()

  const [update, { loading }] = useMutation(UPDATE_CART)

  const handleAdd = useCallback(() => {
    void update({ variables: { utensils: true } })
  }, [update])

  const handleDestroy = useCallback(() => {
    void update({ variables: { utensils: false } })
  }, [update])

  return utensils ? (
    <div className="checkout-order__product / checkout-item">
      <div className="checkout-item__inner">
        <div className="checkout-item__info">
          <b>Utensils</b>
        </div>

        <div className="checkout-item__price">
          <span>Free</span>

          <button className="checkout-item__edit" type="button" onClick={showControls}>
            <svg
              className="sociavore-icon"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </button>
        </div>
      </div>

      <div
        className={clsx('checkout-item__controls', { 'checkout-item__controls_loading': loading })}
        hidden={!isShowControls}
      >
        <div className="checkout-item__remove">
          <button className="btn" onClick={handleDestroy}>
            Remove
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div className="checkout-order__product  checkout-order__product_utensils / checkout-item / text-center">
      <button className="btn btn-accent" type="submit" onClick={handleAdd}>
        Add utensils to order
      </button>
    </div>
  )
}

export default Utensils
